export enum NewMatchEmailTemplate {
    detail = 3727,
    summary = 3728
}